<template>
  <b-card class="text-center py-5">
    <feather-icon icon="CheckCircleIcon" size="64" class="text-success mb-3" />

    <!-- Title -->
    <h3 class="font-weight-bold text-dark">Thank you for your request.</h3>

    <!-- Subtitle -->
    <p class="text-muted mb-4">
      We are currently processing it and will send you a confirmation via Email/WhatsApp within 2 × 24 hours.
    </p>

    <!-- Back to Home Button -->
    <b-button
      variant="primary"
      :to="{ name: 'home' }"
      class="d-inline-flex align-items-center mx-auto"
    >
      <feather-icon icon="ChevronLeftIcon" size="18" class="mr-1" />
      <span>Back to Home</span>
    </b-button>
  </b-card>
</template>

<script>
import {
  BContainer, 
  BRow,
  BCol,
  BButton,
  BCard,
  BCardText,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BImg,
  BFormTextarea,
  BCollapse,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BCard,
    BCardText,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BImg,
    BFormTextarea,
    BCollapse,
  },
  mounted() {
    const status = this.$route.params.status
    console.log('Status:', status)
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/quill.scss';
</style>

<style scoped>


</style>
